import { Control } from 'leaflet';
import { addZoomControlMarkup } from './lib/utils/addZoomControlMarkup';
/**
 * The zoom control.
 */
export class ControlZoom extends Control.Zoom {
    /**
     * Create a new zoom control instance.
     * @param options - The zoom control options.
     */
    constructor(options) {
        super(options);
        this._options = options;
    }
    /**
     * Add custom zoom control markup
     * @param maap - The M.A.A.P. instance.
     */
    addCustomMarkup(maap) {
        addZoomControlMarkup(maap);
        if (this._container) {
            this._container.classList.add('maap_p-bottom-controls__control');
        }
    }
}
//# sourceMappingURL=ControlZoom.js.map